/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 総合契約構成
 */
export interface Sgkb575aResCombinedcontractKosei {
    /** 
     * 受付履歴番号通番：半角数字
     */
    aceptRrknoSerialnumber?: string;
    /** 
     * ガス供給地点特定番号：半角数字
     */
    gasSuppntSpno?: string;
    /** 
     * 処理区分コード：半角英数混在
     */
    processDivCode?: string;
    /** 
     * 使用者需要者区分：半角英数混在
     */
    userCnsdiv?: string;
    /** 
     * 使用者お客さま漢字氏名：全角文字
     */
    userName?: string;
    /** 
     * 使用者お客さまカナ氏名：全角カナ
     */
    userKanaName?: string;
    /** 
     * 使用者お客さま電話番号コード１：半角英数混在
     */
    userTeldv1?: string;
    /** 
     * 使用者お客さま電話番号コード１名称：全角半角混在
     */
    userTeldv1Aname?: string;
    /** 
     * 使用者お客さま電話番号１：電話番号(ハイフンと数値含む)
     */
    userTelNo1?: string;
    /** 
     * 使用者お客さま電話番号コード２：半角英数混在
     */
    userTeldv2?: string;
    /** 
     * 使用者お客さま電話番号コード２名称：全角半角混在
     */
    userTeldv2Aname?: string;
    /** 
     * 使用者お客さま電話番号２：電話番号(ハイフンと数値含む)
     */
    userTelNo2?: string;
    /** 
     * 使用者お客さま電話番号コード３：半角英数混在
     */
    userTeldv3?: string;
    /** 
     * 使用者お客さま電話番号コード３名称：全角半角混在
     */
    userTeldv3Aname?: string;
    /** 
     * 使用者お客さま電話番号３：電話番号(ハイフンと数値含む)
     */
    userTelNo3?: string;
    /** 
     * 使用場所住所コード：半角英数混在
     */
    empposAddrcd?: string;
    /** 
     * 使用場所郵便番号：半角数字
     */
    empposPostno?: string;
    /** 
     * 使用場所都道府県名称：全角文字
     */
    empposPfcAname?: string;
    /** 
     * 使用場所市区郡町村名称：全角文字
     */
    empposMptAname?: string;
    /** 
     * 使用場所町域名称：全角文字
     */
    empposTwareaAname?: string;
    /** 
     * 使用場所大字丁目名称：全角文字
     */
    empposOazaAname?: string;
    /** 
     * 使用場所住宅・棟号漢字名：全角文字
     */
    empposSupadrAname?: string;
    /** 
     * 使用場所住宅・棟号カナ名：全角文字
     */
    empposSupadrKananm?: string;
    /** 
     * 使用場所屋号・業種漢字名：全角文字
     */
    empposYagouAname?: string;
    /** 
     * 使用場所屋号・業種カナ名：全角文字
     */
    empposYagouKananm?: string;
    /** 
     * メーター指針値：半角数値(小数点なし)
     */
    meterShshnch?: number;
    /** 
     * メーター用途コード：半角英数混在
     */
    meterUsecode?: string;
    /** 
     * メーター用途コード名称：全角半角混在
     */
    meterusageCodeaname?: string;
    /** 
     * メーター用途詳細：全角文字
     */
    meterDetailedusage?: string;
    /** 
     * 使用場所住所番地・号・分筆号：全角文字
     */
    empposAddrBlockgoulot?: string;
    /** 
     * ＷＴ受付結果ファイル連係管理番号：半角数字
     */
    wtUktskFilelinkagemanagementnumber?: string;
    /** 
     * ＷＴ結果ファイル連係管理番号：半角数字
     */
    wtResultFilelinkagemanagementnumber?: string;
}
